import { TableColumnMeta } from "ds/components/Table/types";

export const TEMPLATE_DEPLOYMENTS_COLUMNS_STORAGE_KEY = "templateDeploymentsColumnsConfig";

export enum TEMPLATE_DEPLOYMENTS_COLUMN_ID {
  NAME = "NAME",
  VERSION = "VERSION",
  STATUS = "STATUS",
  DEPLOYMENT_TYPE = "DEPLOYMENT_TYPE",
  CREATED_AT = "CREATED_AT",
  DROPDOWN = "DROPDOWN",
}

const MAX_CELL_WIDTH = 2000;

export const TEMPLATE_DEPLOYMENTS_COLUMN_CONFIG: Record<
  TEMPLATE_DEPLOYMENTS_COLUMN_ID,
  TableColumnMeta
> = {
  [TEMPLATE_DEPLOYMENTS_COLUMN_ID.NAME]: {
    id: TEMPLATE_DEPLOYMENTS_COLUMN_ID.NAME,
    title: "Name",
    minWidth: 180,
    defaultWidth: 180,
    maxWidth: MAX_CELL_WIDTH,
    allowsSorting: false,
    resizable: true,
    canHide: true,
    canPin: true,
    canMove: true,
  },
  [TEMPLATE_DEPLOYMENTS_COLUMN_ID.STATUS]: {
    id: TEMPLATE_DEPLOYMENTS_COLUMN_ID.STATUS,
    title: "Status",
    minWidth: 160,
    defaultWidth: 160,
    maxWidth: MAX_CELL_WIDTH,
    allowsSorting: false,
    resizable: true,
    canHide: true,
    canPin: true,
    canMove: true,
  },
  [TEMPLATE_DEPLOYMENTS_COLUMN_ID.VERSION]: {
    id: TEMPLATE_DEPLOYMENTS_COLUMN_ID.VERSION,
    title: "Version deployed",
    minWidth: 150,
    defaultWidth: 200,
    maxWidth: MAX_CELL_WIDTH,
    resizable: true,
    canHide: true,
    canPin: true,
    canMove: true,
  },
  [TEMPLATE_DEPLOYMENTS_COLUMN_ID.DEPLOYMENT_TYPE]: {
    id: TEMPLATE_DEPLOYMENTS_COLUMN_ID.DEPLOYMENT_TYPE,
    title: "Type",
    minWidth: 120,
    defaultWidth: 120,
    maxWidth: MAX_CELL_WIDTH,
    allowsSorting: false,
    resizable: true,
    canHide: true,
    canPin: true,
    canMove: true,
  },
  [TEMPLATE_DEPLOYMENTS_COLUMN_ID.CREATED_AT]: {
    id: TEMPLATE_DEPLOYMENTS_COLUMN_ID.CREATED_AT,
    title: "Created at",
    minWidth: 180,
    defaultWidth: 200,
    maxWidth: MAX_CELL_WIDTH,
    allowsSorting: true,
    resizable: true,
    canHide: true,
    canPin: true,
    canMove: true,
  },
  [TEMPLATE_DEPLOYMENTS_COLUMN_ID.DROPDOWN]: {
    id: TEMPLATE_DEPLOYMENTS_COLUMN_ID.DROPDOWN,
    title: "Version actions",
    noHeader: true,
    minWidth: 60,
    defaultWidth: 60,
    maxWidth: 60,
    allowsSorting: false,
    resizable: false,
    canHide: false,
    configurable: false,
    canPin: false,
    canMove: false,
  },
};

export const TEMPLATE_DEPLOYMENTS_SORT_CONFIG: Record<string, string> = {
  [TEMPLATE_DEPLOYMENTS_COLUMN_ID.NAME]: "name",
  [TEMPLATE_DEPLOYMENTS_COLUMN_ID.STATUS]: "status",
  [TEMPLATE_DEPLOYMENTS_COLUMN_ID.CREATED_AT]: "createdAt",
};
